import { isPlatformBrowser, NgClass, NgOptimizedImage } from '@angular/common';
import { Component, Input, ElementRef, ViewChild, AfterViewInit, OnDestroy, InjectionToken, PLATFORM_ID, inject } from '@angular/core';
import { Button, Image } from '../../models';
import { RouterLink } from '@angular/router';
import { Media } from '@teamfoster/sdk/image';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [NgOptimizedImage, RouterLink, NgClass],
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  private platformId = inject<InjectionToken<Object>>(PLATFORM_ID);

  @Input() imageUrl: string = '';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() text: string = '';
  @Input() media?: Media;
  @Input() button?: Button;
  @Input() transparentNav: boolean = false;
  @Input() backgroundImage: boolean = false;
  @Input() isSlider: boolean = false;

  @ViewChild('headerElMain') elMain!: ElementRef;

  getBackground(image: string | undefined) {
    if (!image) {
      return '';
    }
    return `url('${image}')`;
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const height = this.elMain.nativeElement.offsetHeight;
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.documentElement.style.removeProperty('--header-height');
    }
  }
}
